"use client";
import React from "react";
import Siderail from "@/components/SideRail";
import CollapsedContent from "./SideRailContent/CollapsedContent";
import FullSizeContent from "./SideRailContent/FullSizeContent";
import { HeroSideRailContainerProps } from "./types";
import useSideRailComponentList from "./useSideRailComponentList";
import isCourseType from "@/utils/functions/isCourseType";

export default function HeroSideRailContainer({
  productData,
  courses,
  pricingData,
  skus,
  programIsEnrollable,
  programIsRetired,
  sideRailImage,
  sideRailTitle,
  sideRailBulletList,
  sideRailHeaderComponents,
  sideRailBodyComponents,
  sideRailCollapsedHeaderComponents,
  sideRailCollapsedBodyComponents,
  sideRailRating,
  sideRailSkillsList,
  sideRailVideoPlayer,
  sideRailImageTitle,
  sideRailStatisticComponent,
  currencySelector,
  straightToCheckout,
}: HeroSideRailContainerProps) {
  const baseProps = {
    productData,
    courses,
    pricingData,
    skus,
    programIsEnrollable,
    programIsRetired,
    sideRailImage,
    sideRailTitle,
    sideRailBulletList,
    sideRailRating,
    sideRailSkillsList,
    sideRailVideoPlayer,
    sideRailImageTitle,
    sideRailStatisticComponent,
    currencySelector,
    straightToCheckout,
  };

  const collapsedComponentList = useSideRailComponentList({
    ...baseProps,
    sideRailBodyComponents,
    sideRailCollapsedBodyComponents,
    isCollapsed: true,
  });

  const fullSizeComponentList = useSideRailComponentList({
    ...baseProps,
    sideRailBodyComponents,
    sideRailCollapsedBodyComponents,
    isCollapsed: false,
  });

  return (
    <Siderail
      className="shadow-hero-rail w-[430px] max-w-full overflow-x-clip rounded-xl"
      stickyTriggerSelector={
        isCourseType(productData.productType)
          ? "#course-details-body-container"
          : "#program-details-body-container"
      }
      stickyStopSelector={
        isCourseType(productData.productType)
          ? "#course-enterprise-cta"
          : "#program-category-cta"
      }
      collapsedContent={
        <CollapsedContent
          componentList={collapsedComponentList}
          sideRailCollapsedHeaderComponents={sideRailCollapsedHeaderComponents}
          sideRailCollapsedBodyComponents={sideRailCollapsedBodyComponents}
        />
      }
    >
      <FullSizeContent
        componentList={fullSizeComponentList}
        sideRailHeaderComponents={sideRailHeaderComponents}
        sideRailBodyComponents={sideRailBodyComponents}
      />
    </Siderail>
  );
}
